'use client';

import type { NextPage } from 'next';
import { useInitialPageLoad } from '@/hooks/general/useInitialPageLoad';
import { DefaultPageProps } from '@/types/types/page/pages';
import { IIntroIconData } from '@/types/types/page/homePage';
import { MainContentWrapper } from '@/components/layout/MainContentWrapper/MainContentWrapper';
import { Home } from '@/components/main/Home/Home';

interface HomePageProps extends DefaultPageProps {
    introIconsData: IIntroIconData[];
}

const HomePage: NextPage<HomePageProps> = ({
    phrases,
    dictionary,
    registrationTemplate,
    introIconsData,
}) => {
    useInitialPageLoad({ phrases, countries: dictionary.countries });

    return (
        <MainContentWrapper phrases={phrases} dictionary={dictionary} className="page-home">
            <Home
                dictionary={dictionary}
                registrationTemplate={registrationTemplate}
                introIconsData={introIconsData}
            />
        </MainContentWrapper>
    );
};

export default HomePage;
